<div class="fade-in control-overlay" fxFlexFill>
   <div fxLayout="row" fxFlexFill>
      <div class="control-bar" fxFlexAlign="center" fxLayout="column" fxFlex="1 1 100">
         <div class="brick-title">
            <fa-icon [icon]="(brickInstanceId | instanceIdToBrickDescription$ | async).definition.brickIcon"></fa-icon>
            {{ brickInstanceId | instanceIdToBrickTitle$ | async }}
         </div>
         <div fxLayout="row" fxLayoutAlign="center center">
            <samweb-brick-setting-button
               class="sam-clickable control-icon sam-margin"
               [brickInstanceId]="brickInstanceId"
            ></samweb-brick-setting-button>
            <fa-icon
               class="sam-clickable control-icon sam-margin sam-red"
               [icon]="removeBrickIcon"
               [fixedWidth]="true"
               (click)="removeBrick()"
            ></fa-icon>
         </div>
      </div>
   </div>
</div>
